import { render, staticRenderFns } from "./LiveStatus.vue?vue&type=template&id=f20ebf78&scoped=true&"
import script from "./LiveStatus.vue?vue&type=script&lang=js&"
export * from "./LiveStatus.vue?vue&type=script&lang=js&"
import style0 from "./LiveStatus.vue?vue&type=style&index=0&id=f20ebf78&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f20ebf78",
  null
  
)

export default component.exports